import { render, staticRenderFns } from "./FormTextareaInput.vue?vue&type=template&id=faa56ae0"
import script from "./FormTextareaInput.vue?vue&type=script&lang=js"
export * from "./FormTextareaInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports